export default "__VITE_ASSET__ad276400__"